import { ShmoozShadowLogo } from '../../assets/images';
import Separator from '../FormFields/Separator';
import { H3, Body2, Body3, H5, H4 } from '../../themes/typography';
import { CalendarIcon } from '../../icons/FontAwesomeIcon';
import '../../styles/components/EventTicket.css';
import { formatEventDate } from '../../utils/dateFormatter';

export default function TicketPreview({
    ticketId,
    ticketName,
    ticketDescription,
    ticketValidDates,
    saleEndsOn,
    discountedPrice,
    originalPrice,
    maxPerUser,
    ticketQuantitySelector,
    saleStatus
}) {
    return (
        <div className="ticket-preview-layout-container">
            <div className="ticket-preview-layout-details-section">
                <div className="ticket-preview-layout-heading-section">
                    <div className="ticket-preview-layout-name-section">
                        <H3 color="#F8A21E">{ticketName}</H3>
                    </div>

                    <div className="ticket-preview-layout-description-section">
                        <Body2>{ticketDescription}</Body2>
                    </div>
                </div>

                <div className="ticket-preview-layout-valid-details-section">
                    <div className="ticket-preview-layout-is-valid-for-section">
                        <H5 color="#F8A21E">Ticket is Valid For</H5>

                        {/* Ticket is valid for dates section */}
                        <div className="ticket-preview-is-valid-dates-section">
                            {ticketValidDates?.map((dateTime, index) => (
                                <div key={index} className="preview-valid-ticket-date-time-slot">
                                    <div className="preview-valid-ticket-date-icon">
                                        <CalendarIcon
                                            style={{ color: '#26C1E8', fontSize: '1.125rem' }}
                                        />
                                    </div>

                                    <div className="preview-valid-ticket-date-time-section">
                                        <div className="preview-valid-ticket-date-section">
                                            <Body3 fontWeight={500}>
                                                {formatEventDate(dateTime.date)}
                                            </Body3>
                                        </div>

                                        <div className="preview-valid-ticket-time-section">
                                            <Body3>{`${dateTime.from_time} - ${dateTime.to_time}`}</Body3>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Sale ends on section */}
                    {/* <Body3>Sale ends on {formatEventDate(saleEndsOn)}</Body3> */}
                </div>
            </div>

            <div className="ticket-preview-shmooz-shadow-section">
                <img src={ShmoozShadowLogo} alt="Shmooz" />
            </div>

            <div className="ticket-preview-separator-design-section">
                <div className="preview-separator-top-circle-section"></div>
                <div className="preview-separator-center-line-section"></div>
                <div className="preview-separator-bottom-circle-section"></div>
            </div>

            <div className="ticket-preview-action-area-section">
                <div className="ticket-preview-purchase-design-container">
                    <div className="ticket-preview-qty-title-section">
                        {/* <Body2>Quantity</Body2> */}

                        {ticketQuantitySelector}
                    </div>

                    <div className="ticket-divider-preview">
                        <Separator />
                    </div>

                    <div className="ticket--preview-purchase-price-strike-section">
                        <Body2>Ticket Price</Body2>

                        <div className="purchase-preview-ticket-price-strike-details">
                            {originalPrice === 0 ? (
                                <H4 color="#F8A21E" fontWeight={700}>
                                    Free
                                </H4>
                            ) : (
                                <>
                                    <H4 color="#F8A21E" fontWeight={700}>{`₹ ${originalPrice}`}</H4>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

TicketPreview.defaultProps = {
    ticketId: 1,
    ticketName: 'VIP Sustainable Living Expo Pass',
    ticketDescription:
        'Enjoy exclusive access to VIP areas and special sessions. This ticket grants you enhanced networking opportunities with industry leaders.VIP Sustainable Living Expo Pass',
    ticketValidDates: [
        {
            date: '2024-11-10',
            startTime: '12:00',
            endTime: '05:00'
        }
    ],
    saleEndsOn: '2024-11-10',
    discountedPrice: 80,
    originalPrice: 100,
    maxPerUser: 5
};
